import { SxProps, Theme } from "@mui/material";

import { DataGrantDto, DataGrantReferenceDto } from "@/core/api/generated/v1";

import GeneralStrictEntityRelationInline from "../General/Display/GeneralStrictEntityRelationInline";
import { BaseEntityInlineInheritableProps } from "../components/EntityInline/BaseEntityInline";

interface Props {
  value: DataGrantDto | DataGrantReferenceDto | null | undefined;
  inlineProps?: BaseEntityInlineInheritableProps;
  sx?: SxProps<Theme>;
}

export default function DataGrantEntityInline({ value, inlineProps, sx }: Props) {
  if (!value) {
    return null;
  }
  return (
    <GeneralStrictEntityRelationInline
      value={{ entityType: value.grantEntityType || value.entityType, entityId: value.entityId }}
      inlineProps={inlineProps}
      sx={sx}
    />
  );
}
